// third-party
import { isDate } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

// project imports
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';
import {
    processEntityInput as processEntityInputSafeDeleter,
    processEntityOutput as processEntityOutputSafeDeleter
} from 'store/serializers/fragments/safe-deleter';
import { getIriFromObj } from 'utils/processors';

const calculateWorkDuration = (hours, minutes) => {
    if (hours === undefined && minutes === undefined) return undefined;
    if (hours === null && minutes === null) return undefined;

    const h = Number(hours || 0);
    const m = Number(minutes || 0);

    return h * 60 + m;
};

export const processEntityInput = (values) => ({ ...values, ...processEntityInputMain(values), ...processEntityInputSafeDeleter(values) });

export const processEntityOutput = (values) => ({
    ...values,
    ...processEntityOutputMain(values),
    ...processEntityOutputSafeDeleter(values),
    task: 'task' in (values || {}) ? getIriFromObj(values.task) : undefined,
    ticketType: 'ticketType' in (values || {}) ? getIriFromObj(values.ticketType) : undefined,
    client: 'client' in (values || {}) ? getIriFromObj(values.client) : undefined,
    clientLocation:
        'clientLocation' in (values || {}) && values?.clientLocation?.id ? `/common/locations/${values?.clientLocation?.id}` : undefined, // getIriFromObj(values.clientLocation)
    startDate:
        'startDate' in (values || {}) && isDate(values.startDate)
            ? formatInTimeZone(values.startDate, 'Africa/Luanda', 'yyyy-MM-dd HH:mm:ssXXX')
            : undefined,
    endDate:
        'endDate' in (values || {}) && isDate(values.endDate)
            ? formatInTimeZone(values.endDate, 'Africa/Luanda', 'yyyy-MM-dd HH:mm:ssXXX')
            : undefined,
    workDuration:
        'hours' in (values || {}) || 'minutes' in (values || {})
            ? calculateWorkDuration(values?.hours, values?.minutes)
            : values?.workDuration,
    nonExistentClientCheck: undefined,
    signTicketCheck: undefined,
    hours: undefined,
    minutes: undefined,
    signature: undefined
});
